// extracted by mini-css-extract-plugin
module.exports = {"departments":"ok","departmentHeading":"pk","departmentSection":"qk","departmentName":"rk","departmentLink":"sk","expandIcon":"tk"};